import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ApiHook } from "../../hooks/apiHook";

const RpsComponent = () => {
  const { t, i18n } = useTranslation();
  const rpsQuery = ApiHook.CallRpsStatus();
  const rpsData = rpsQuery?.data?.data;

  if (!rpsData) return null;

  const lang = i18n.language;
  const statusName = lang === "ar" ? rpsData.current.nameAr : rpsData.current.nameEn;
  const nextName = rpsData.next
    ? lang === "ar"
      ? rpsData.next.nameAr
      : rpsData.next.nameEn
    : null;

  return (
    <div className="col-md-4">
      <div className="ranking-box">
        <div className="joinings_viewBox_head">
          <h5>{t("rps_performance_status")}</h5>
        </div>
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="fw-bold">{t("rps_current_status")}</span>
            <span
              className={`badge ${
                rpsData.current.isBaseline ? "bg-secondary" : "bg-success"
              }`}
            >
              {statusName || rpsData.current.slug}
            </span>
          </div>

          <div className="row mb-2">
            <div className="col-6">
              <small className="text-muted">{t("rps_direct_pv")}</small>
              <div className="fw-bold">
                {parseFloat(rpsData.directPv).toLocaleString()}
              </div>
            </div>
            <div className="col-6">
              <small className="text-muted">{t("rps_group_pv")}</small>
              <div className="fw-bold">
                {parseFloat(rpsData.groupPv).toLocaleString()}
              </div>
            </div>
          </div>

          {rpsData.factors && (
            <div className="mt-3 border-top pt-3">
              <small className="text-muted d-block mb-2 fw-bold">
                {t("rps_commission_impact")}
              </small>
              <div className="row g-2">
                {[
                  { key: "levelCommission", label: t("rps_factor_level") },
                  { key: "poolWeight", label: t("rps_factor_pool") },
                  { key: "infinityWeight", label: t("rps_factor_infinity") },
                  { key: "rankBonus", label: t("rps_factor_rank") },
                ].map(({ key, label }) => (
                  <div className="col-6" key={key}>
                    <div className="border rounded p-2 text-center">
                      <small className="text-muted d-block">{label}</small>
                      <span
                        className={`fw-bold ${
                          rpsData.factors[key] < 1
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {(rpsData.factors[key] * 100).toFixed(0)}%
                      </span>
                    </div>
                  </div>
                ))}
                {rpsData.factors.directCommissionBonus?.enabled && (
                  <div className="col-12 mt-2">
                    <div className="border rounded p-2 text-center border-warning">
                      <small className="text-muted d-block">
                        {t("rps_direct_bonus")}
                      </small>
                      <span className="fw-bold text-warning">
                        +{rpsData.factors.directCommissionBonus.percentage}%
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {rpsData.next && (
            <div className="mt-3 border-top pt-3">
              <small className="text-muted d-block mb-1">
                {t("rps_next_level")}: <strong>{nextName || rpsData.next.slug}</strong>
              </small>
              <div className="row">
                <div className="col-6">
                  <small>{t("rps_remaining_direct")}</small>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-primary"
                      style={{
                        width: `${Math.min(
                          100,
                          (parseFloat(rpsData.directPv) /
                            Math.max(parseFloat(rpsData.next.minDirectPv), 1)) *
                            100
                        )}%`,
                      }}
                    />
                  </div>
                  <small className="text-muted">
                    {parseFloat(rpsData.next.remainingDirectPv).toLocaleString()}{" "}
                    {t("rps_remaining")}
                  </small>
                </div>
                <div className="col-6">
                  <small>{t("rps_remaining_group")}</small>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-info"
                      style={{
                        width: `${Math.min(
                          100,
                          (parseFloat(rpsData.groupPv) /
                            Math.max(parseFloat(rpsData.next.minGroupPv), 1)) *
                            100
                        )}%`,
                      }}
                    />
                  </div>
                  <small className="text-muted">
                    {parseFloat(rpsData.next.remainingGroupPv).toLocaleString()}{" "}
                    {t("rps_remaining")}
                  </small>
                </div>
              </div>
            </div>
          )}

          {rpsData.evaluatedAt && (
            <div className="mt-2 text-end">
              <small className="text-muted">
                {t("rps_last_evaluated")}:{" "}
                {new Date(rpsData.evaluatedAt).toLocaleDateString()}
              </small>
            </div>
          )}
          <div className="mt-3 text-center">
            <Link to="/rps-status" className="btn btn-sm btn-outline-primary">
              {t("rps_view_details")} <i className="fa fa-arrow-right ms-1"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RpsComponent;
